import { apiService } from './api';
import { AssetTypeDef, AssetTypeDefCreate, AssetTypeDefUpdate, AssetTypeUsage } from '../types';

export const assetTypeRegistryService = {
  assets(id: string): Promise<AssetTypeUsage[]> {
    return apiService.get<AssetTypeUsage[]>(`/asset-type-registry/${id}/assets`, { limit: 10 });
  },
  get(id: string): Promise<AssetTypeDef> {
    return apiService.get<AssetTypeDef>(`/asset-type-registry/${id}`);
  },
  list(includeInactive = false, includeShadowed = false): Promise<AssetTypeDef[]> {
    return apiService.get<AssetTypeDef[]>('/asset-type-registry/', {
      include_inactive: includeInactive,
      include_shadowed: includeShadowed,
    });
  },

  create(payload: AssetTypeDefCreate): Promise<AssetTypeDef> {
    return apiService.post<AssetTypeDef>('/asset-type-registry/', payload);
  },

  update(id: string, payload: AssetTypeDefUpdate): Promise<AssetTypeDef> {
    return apiService.patch<AssetTypeDef>(`/asset-type-registry/${id}`, payload);
  },

  remove(id: string): Promise<AssetTypeDef> {
    return apiService.delete<AssetTypeDef>(`/asset-type-registry/${id}`);
  },
};
